import { render } from "./printsGallery.vue?vue&type=template&id=70d963c8&scoped=true"
import script from "./printsGallery.vue?vue&type=script&lang=js"
export * from "./printsGallery.vue?vue&type=script&lang=js"

import "./printsGallery.vue?vue&type=style&index=0&id=70d963c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d963c8"]])

export default __exports__